import { lazyRouteComponent } from "@tanstack/react-router";
import { CreditCard } from "lucide-react";

import type { PageDef } from "@/app/registry";

export const pages: PageDef[] = [
  {
    path: "/app/payment",
    title: "Payment",
    component: lazyRouteComponent(() => import("./PaymentPage"), "PaymentPage"),
    nav: { label: "Payment", icon: CreditCard, group: "System", order: 91 },
    // admins don't pay; the server answers for anyone signed in
    roles: ["ra", "investor"],
    // ?plan=investor_pro preselects a plan (the upgrade links for RA clients)
    validateSearch: (s) => (typeof s.plan === "string" ? { plan: s.plan } : {}),
  },
];

/** Where PayU sends the payer back (V068): works signed out, like /verify-email. */
export const publicPages: PageDef[] = [
  {
    path: "/payment-result",
    title: "Payment",
    component: lazyRouteComponent(() => import("./PaymentResultPage"), "PaymentResultPage"),
    validateSearch: (s) => ({
      ...(typeof s.txn === "string" ? { txn: s.txn } : {}),
      ...(typeof s.sig === "string" ? { sig: s.sig } : {}),
    }),
  },
];
